import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { addLoading, removeLoading } from '../../../commonAction'

const apiGetListServicesRatingByOffices = `${host}admin/exportJSON/officeServiceRating`

export const getListServicesRatingByOffices = ({
    FromDate,
    ToDate,
    BranchIDs,
    RatingType,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        RatingType,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByOffices,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_SERVICES_RATING_BY_OFFICE,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    RatingType,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_SERVICES_RATING_BY_OFFICE_ERROR,
            () => false
        )
    }
}

export const exportListServicesRatingByOffices = ({
    FromDate,
    ToDate,
    BranchIDs,
    RatingType,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        RatingType,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByOffices,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
